import {
    CLEAR_PROBABILITY_BY_DRAW,
    FETCH_PROBABILITY_BY_DRAW,
    LIST_PROBABILITY_BY_DRAW, LIST_PROBABILITY_TYPE,
} from "./types";

const init = {
    isLoading: false,
    list: [],
    filter: {},
    probabilityTypes: []
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_PROBABILITY_BY_DRAW:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_PROBABILITY_BY_DRAW:
            return {
                ...state,
                isLoading: false,
                list: payload.data
            };
        case LIST_PROBABILITY_TYPE:
            return {
                ...state,
                isLoading: false,
                probabilityTypes: payload.data
            };
        case CLEAR_PROBABILITY_BY_DRAW:
            return {
                ...init
            };
        default:
            return state;
    }
}
